var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cancel"},[_c('ByIcon',{staticClass:"icon",attrs:{"icon":"cancel","size":"18"},nativeOn:{"click":function($event){return _vm.closeWindow.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }